import RestApiModel from "@/api/Model/RestApiModel";

class Role extends RestApiModel {

  static getResourceEndpoint() {
    return '/roles';
  }
}

export default Role;
